import Client from "src/api/client";
import { GetOptions } from "src/api/types/client";

const fetcher = async (path: string, query: GetOptions["query"]) => {
  const response = await Client.get({ path, query });
  return response;
};

export default fetcher;
